import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";


export const GET_PAYER_GROUP_TYPE_LIST = "GET_PAYER_GROUP_TYPE_LIST";

export const service = async () => {
    const options: object = {
        url: `/Api/PayerGroup/GetPayerGroupTypeList`,
        method: 'GET',  
    }; 

    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};

register(GET_PAYER_GROUP_TYPE_LIST, service, mock);